
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10 3.333a6.242 6.242 0 016.125 5.034C18.292 8.517 20 10.3 20 12.5c0 2.3-1.867 4.167-4.167 4.167H5c-2.758 0-5-2.242-5-5 0-2.575 1.95-4.7 4.458-4.967A6.246 6.246 0 0110 3.333zm1.667 10.834v-3.334h2.5L10.3 6.958a.413.413 0 00-.592 0l-3.875 3.875h2.5v3.334h3.334z","fill":"#7F91A8"}})])
          )
        }
      }
    